import { useCallback } from 'react';

import { SUMMARY_TAB, TRANSCRIPT_TAB } from './useAppointmentTabNav';

/**
 * "Open in transcript" / "Open in note" from the Care Plan evidence drawer:
 * opens the target tab of the current appointment in a new browser tab so the
 * reviewer can read the source without losing their place in the review. No
 * evidence text is passed — it stays out of the URL (and therefore out of
 * browser history, proxy logs, and analytics that capture the location).
 */
export const useOpenSourceTab = () => {
  const openInNewTab = useCallback((tab: string) => {
    const url = new URL(window.location.href);
    url.searchParams.set('tab', tab);
    window.open(url.toString(), '_blank', 'noopener');
  }, []);

  const openTranscriptInNewTab = useCallback(
    () => openInNewTab(TRANSCRIPT_TAB),
    [openInNewTab],
  );

  const openNoteInNewTab = useCallback(
    () => openInNewTab(SUMMARY_TAB),
    [openInNewTab],
  );

  return { openTranscriptInNewTab, openNoteInNewTab };
};
